// @flow
import ProductGallery from './ProductGallery';
import ProductGalleryThumb from './ProductGalleryThumb';

export default ProductGallery;
export { ProductGalleryThumb };
